import { React, useState, useEffect, useContext } from "react";
import { XIcon } from "@heroicons/react/outline";
import { fetchData } from "./api-handlers";
import routes from "../../config/routes-config";
import { LoginContext } from "../../contexts/LoginContext";

export const ProjectDetailsModal = ({ show, onCloseCallback, projectId }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const { userAuthStatus, user } = useContext(LoginContext);

  const [starData, setStarData] = useState(null);
  const [currTabData, setCurrentTabData] = useState(null);

  useEffect(() => {
    if (userAuthStatus && user !== null) {
      const url = routes.project.projectStars + "?projectId=" + projectId;
      fetchData(url, setStarData, setCurrentTabData, user.token);
    }
  }, [projectId, user, userAuthStatus]);

  const setTabData = (currTab) => {
    if (currTab === 0) {
      setCurrentTab(0);
      setCurrentTabData(starData.allStarCardModels);
    } else if (currTab === 1) {
      setCurrentTab(1);
      setCurrentTabData(starData.allStarCardStudent);
    } else if (currTab === 2) {
      setCurrentTab(2);
      setCurrentTabData(starData.allStarCardTeacher);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className="fixed top-0 right-0 left-0 bottom-0 overflow-y-auto overflow-x-hidden flex justify-center items-center z-50 md:inset-0 h-modal md:h-full bg-[rgba(0,0,0,0.6)]"
    >
      <div className="relative p-4 w-full max-w-lg h-full md:h-auto">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          {/* <!-- Modal header --> */}
          <div className="flex flex-row place-items-center justify-end py-4 px-6">
            <h1 className="text-2xl text-[#1C42D5] font-medium">Starred by</h1>
            <button
              onClick={() => onCloseCallback()}
              type="button"
              className="rounded-lg text-sm ml-auto inline-flex items-center"
              data-modal-toggle="popup-modal"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          {/* <!-- Modal body --> */}
          <div className="p-6 pt-0 text-center">
            <div className="font-medium text-center border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
              <ul className="flex flex-wrap -mb-px">
                <li className="mr-2">
                  <button
                    onClick={() => setTabData(0)}
                    className={`inline-block p-4 rounded-t-lg ${
                      currentTab === 0
                        ? "text-[#1C42D5] border-b-2 border-[#1C42D5] active dark:text-[#3757d6] dark:border-[#3757d6]"
                        : "border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                    }`}
                  >
                    <div className="flex flex-row justify-between place-items-center text-lg ">
                      <h1 className="mr-2">All</h1>
                      <h1
                        className={`${
                          currentTab === 0 ? "text-[#647de1]" : "text-gray-400"
                        }`}
                      >
                        {starData.totalStar}
                      </h1>
                    </div>
                  </button>
                </li>
                <li className="mr-2">
                  <button
                    onClick={() => setTabData(1)}
                    className={`inline-block p-4 rounded-t-lg ${
                      currentTab === 1
                        ? "text-[#1C42D5] border-b-2 border-[#1C42D5] active dark:text-[#3757d6] dark:border-[#3757d6]"
                        : "border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                    }`}
                  >
                    <div className="flex flex-row justify-between place-items-center text-lg ">
                      <h1 className="mr-2">Students</h1>
                      <h1
                        className={`${
                          currentTab === 1 ? "text-[#647de1]" : "text-gray-400"
                        }`}
                      >
                        {starData.countOfStudent}
                      </h1>
                    </div>
                  </button>
                </li>
                <li className="mr-2">
                  <button
                    onClick={() => setTabData(2)}
                    className={`inline-block p-4 rounded-t-lg ${
                      currentTab === 2
                        ? "text-[#1C42D5] border-b-2 border-[#1C42D5] active dark:text-[#3757d6] dark:border-[#3757d6]"
                        : "border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                    }`}
                  >
                    <div className="flex flex-row justify-between place-items-center text-lg ">
                      <h1 className="mr-2">Professors</h1>
                      <h1
                        className={`${
                          currentTab === 2 ? "text-[#647de1]" : "text-gray-400"
                        }`}
                      >
                        {starData.countOfTeacher}
                      </h1>
                    </div>
                  </button>
                </li>
              </ul>
            </div>

            <ul className="divide-y divide-gray-200 dark:divide-gray-700 h-96 overflow-y-auto">
              {currTabData &&
                currTabData.map((profile, index) => (
                  <li className="py-3" key={index}>
                    <div className="flex items-center space-x-4">
                      <div className="flex-shrink-0">
                        <img
                          className="w-10 h-10 rounded-full"
                          src={profile.pictureUrl}
                          alt="Profile"
                        />
                      </div>
                      <div className="flex-1 min-w-0 text-left">
                        <p className="font-medium text-gray-900 truncate dark:text-white">
                          {profile.name}
                        </p>
                        <p className="text-gray-500 truncate dark:text-gray-400">
                          {profile.department}
                        </p>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
